import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "or",
  "use": "or-usage",
  "viewBox": "0 0 18 9",
  "content": "<symbol viewBox=\"0 0 18 9\" xmlns=\"http://www.w3.org/2000/svg\" id=\"or\"><path d=\"M9.112 4.5c0 2.523-2.009 4.5-4.55 4.5C2.008 9 0 7.023 0 4.5 0 1.977 2.008 0 4.562 0c2.541 0 4.55 1.977 4.55 4.5zm-4.55 2.586c1.29 0 2.256-1.082 2.256-2.586 0-1.504-.967-2.586-2.256-2.586-1.302 0-2.256 1.082-2.256 2.586 0 1.504.954 2.586 2.256 2.586zM18 8.85h-2.579l-1.475-3.145h-1.252V8.85h-2.28V.149h3.718c.62 0 1.19.087 1.686.274 1.03.385 1.699 1.193 1.699 2.449 0 .646-.199 1.18-.546 1.603-.235.286-.52.522-.868.709L18 8.85zm-5.306-4.96h1.401c.26 0 .484-.037.67-.124.297-.137.47-.398.47-.808 0-.41-.173-.672-.47-.82a1.567 1.567 0 0 0-.67-.138h-1.4v1.89z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/or.svg
// module id = 1558
// module chunks = 0